import { NavLink } from "react-router-dom";
import { House, MagnifyingGlass, Plus, Heart, User } from "@phosphor-icons/react";

const items = [
  { to: "/", label: "Ana", icon: House, testid: "mobnav-home" },
  { to: "/kesfet", label: "Keşfet", icon: MagnifyingGlass, testid: "mobnav-explore" },
  { to: "/ilan-ver", label: "Sat", icon: Plus, testid: "mobnav-create", primary: true },
  { to: "/panelim?tab=favorites", label: "Favoriler", icon: Heart, testid: "mobnav-favorites" },
  { to: "/panelim", label: "Panel", icon: User, testid: "mobnav-dashboard" },
];

export default function MobileBottomNav() {
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t divider"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-5 h-16">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.to === "/"}
            data-testid={it.testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors ${
                it.primary
                  ? "text-slate-900"
                  : isActive
                    ? "text-slate-900"
                    : "text-slate-400 hover:text-slate-700"
              }`
            }
          >
            {it.primary ? (
              <span className="w-9 h-9 rounded-full bg-slate-900 text-white flex items-center justify-center">
                <it.icon size={18} weight="bold" />
              </span>
            ) : (
              <it.icon size={20} weight="regular" />
            )}
            <span>{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
